import {
  ActionTypes as ABTestActionTypes,
  Constants as ABTestConstants,
  Actions as ABTestActions,
} from './abTest'
import {
  ActionTypes as AccountActionTypes,
  Constants as AccountConstants,
  Actions as AccountActions,
} from './account'
import {
  ActionTypes as CartActionTypes,
  Constants as CartConstants,
  Actions as CartActions,
} from './cart'
import {
  ActionTypes as CookieActionTypes,
  Constants as CookieConstants,
  Actions as CookieActions,
} from './cookie'
import {
  ActionTypes as CollectionActionTypes,
  Constants as CollectionConstants,
  Actions as CollectionActions,
} from './collection'
import {
  ActionTypes as FavoriteActionTypes,
  Constants as FavoriteConstants,
  Actions as FavoriteActions,
} from './favorite'
import {
  ActionTypes as FollowActionTypes,
  Constants as FollowConstants,
  Actions as FollowActions,
} from './follow'
import {
  ActionTypes as SessionActionTypes,
  Constants as SessionConstants,
  Actions as SessionActions,
} from './session'
import {
  IsInitialLoadReadyActionTypes,
  isInitialLoadReadyConstant,
  IsInitialLoadReadyActions,
} from './isInitialLoadReady'

// CONSTANTS
export const Constants = {
  ...ABTestConstants,
  ...AccountConstants,
  ...CartConstants,
  ...CookieConstants,
  ...CollectionConstants,
  ...FavoriteConstants,
  ...FollowConstants,
  ...SessionConstants,
  ...isInitialLoadReadyConstant,
}

// ACTION TYPES
export type ActionTypes =
  | ABTestActionTypes
  | AccountActionTypes
  | CartActionTypes
  | CookieActionTypes
  | CollectionActionTypes
  | FavoriteActionTypes
  | FollowActionTypes
  | SessionActionTypes
  | IsInitialLoadReadyActionTypes

// ACTION CALLS
export const Actions = {
  ...ABTestActions,
  ...AccountActions,
  ...CartActions,
  ...CookieActions,
  ...CollectionActions,
  ...FavoriteActions,
  ...FollowActions,
  ...SessionActions,
  ...IsInitialLoadReadyActions,
}
